import { AbstractPmsApiService } from "./abstract.service";
import { CreditCardType } from "../models";

/**
 * @class CreditCardTypePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<CreditCardType>}
 */
export class CreditCardTypePmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/credit-card-type(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {CreditCardType}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new CreditCardType(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<CreditCardType>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {CreditCardType} creditCardType
     * @returns {Promise.<CreditCardType>}
     */
    create(creditCardType) {
        
        const url = this.url({propertyId: creditCardType.property.id});
        
        return this.http
                   .post(url, creditCardType.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {CreditCardType} creditCardType
     * @returns {Promise.<CreditCardType>}
     */
    update(creditCardType) {
        
        const url = this.url({
            propertyId: creditCardType.property.id,
            id:         creditCardType.id
        });
        
        return this.http
                   .put(url, creditCardType.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {CreditCardType} creditCardType
     * @returns {Promise.<boolean>}
     */
    delete(creditCardType) {
        
        const url = this.url({
            propertyId: creditCardType.property.id,
            id:         creditCardType.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/credit-card-type.service.js